import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Home from '../views/Home.vue';
import VueMain from "@/main";

import store from "@/store/store";
import appointmentModel from '@/models/appointment.model';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
   // =============================================================================
    // START-PAGE
    // =============================================================================
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/cadastro',
    name: 'Cadastro',
    component: () => import( '../views/pages/Signup.vue'),
  },
  {
    path: '/recuperar-senha',
    name: 'Recuperarsenha',
    component: () => import('../views/pages/PasswordRecovery.vue'),
  },
  {
    path: '/canal-de-privacidade',
    name: 'Canal de privacidade',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/PrivacyChannel.vue'),
  },
  {
    path: '/deletar-usuario',
    name: 'Deletar usuário',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/DeleteUser.vue'),
  },
  {
    path: '/encontrar-psicologo',
    name: 'Encontrar psicologo',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/SearchPsychologist.vue'),
  },
  {
    path: '/faq',
    name: 'Faq',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/Faq.vue'),
  },
  {
    path: '/contato',
    name: 'Contato',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/Contact.vue'),
  },
  {
    path: '/areadocliente',
    name: 'ClientLogin',
    component: () => import(/* webpackChunkName: "about" */ '../views/pages/clientarea/ClientLogin.vue'),
  },
  // =============================================================================
  // LOGGED IN ROUTES
  // =============================================================================
  {
    path: '/dash',
      component: () => import('../views/pages/logged-in-page/Main.vue'),
      redirect: '/dash/agenda',
      meta: { authRequired: true },
      children: [
  // =============================================================================
  // LOGGED IN PAGES
  // =============================================================================
        {
          path: '/dash/minha-conta',
          name: 'minhaconta',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/MyAccount.vue'),
        },
        {
          path: '/dash/busca-psicologo',
          name: 'buscapsicologo',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/Search.vue'),
        },
        {
          path: '/dash/agenda',
          name: 'agenda',
          //meta: { authRequired: true },
          meta: { authRequiredPsyCompleted: true },
          component: () => import('../views/pages/logged-in-page/Schedule.vue'),
        },
        {
          path: '/dash/minhas-consultas',
          name: 'minhasconsultas',
          meta: { authRequired: true },          
          component: () => import('../views/pages/logged-in-page/Appointments.vue'),
        },
        {
          path: '/dash/relatorio-consultas',
          name: 'relatorioconsultas',
          //meta: { authRequired: true },
          meta: { authRequiredPsyCompleted: true },
          component: () => import('../views/pages/logged-in-page/AppointmentsReport.vue'),
        },
        {
          path: '/dash/psicologo/:id',
          name: 'psicologo',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/PsychologistPage.vue'),
        },
        {
          path: '/dash/consulta/:id',
          name: 'Detalhes da consulta',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/AppointmentDetails.vue'),
        },
        {
          path: '/dash/sala/:id',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/VideoRoom.vue'),
        },
        {
          path: '/dash/solicitacoes',
          name: 'solicitacoes',
          //meta: { authRequired: true },
          meta: { authRequiredPsyCompleted: true },
          component: () => import('../views/pages/logged-in-page/PendingAppointments.vue'),
        },
        {
          path: '/dash/perfil',
          name: 'perfil',
          //meta: { authRequired: true },
          meta: { authRequiredPsyCompleted: true },
          component: () => import('../views/pages/logged-in-page/MyProfile.vue'),
        },
        {
          path: '/dash/logout',
          name: 'logout',
          meta: { authRequired: true },
          component: () => import('../views/pages/logged-in-page/Logout.vue'),
        },
        {
          path: '/home-cliente',
          name: 'relatoriocliente',
          meta: { authRequiredCompany: true },
          //component: () => import('../views/pages/clientarea/ClientHome.vue'),
          component: () => import('../views/pages/logged-in-page/AppointmentsReport.vue'),
        },
//         {
//           path: '/minhaconta',
//           name: 'Publicações',
//           meta: { authRequired: true },
//           // component: () => import('./views/pages/logged-in-page/Posts.vue'),
//         },
//         {
//           path: '/agenda',
//           name: 'Publicações',
//           meta: { authRequired: true },
//           // component: () => import('./views/pages/logged-in-page/Posts.vue'),
//         },
      ],
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior () {
    return { x: 0, y: 0 }
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.authRequired && !(store.state as any).auth.isUserLoggedIn()) {
    router.push({ path: "/", query: { to: to.path } });
  }
  if (to.meta.authRequiredCompany && !(store.state as any).auth.isCompanyLoggedIn()) {
    router.push({ path: "/", query: { to: to.path } });
  }
  if (to.meta.authRequiredPsyCompleted) {
    const logged = (store.state as any).auth.isUserLoggedIn();    
    const psycologist = (store.state as any).auth.isUserPsycologist();
    // console.log("logged", logged);
    // console.log("psycologist", psycologist);
    // console.log('from', from);
    if (!logged) {
      router.push({ path: "/", query: { to: to.path } });
    }
    if (psycologist) {
      const incomplete = await appointmentModel.getIncomplete();
      //console.log("incomplete", incomplete);
      if (incomplete !== null && incomplete.id > 0) {
        //alert('Você tem um cadastro incompleto. Por favor, complete seu cadastro para acessar esta página.');
        
        VueMain.$vs.notification({
            title: "Não permitido",
            text: "Existem consultas com prontuários em aberto! Será necessário preenche-los para ter acesso a essa opção!",
            //iconPack: "feather",
            //icon: "icon-alert-circle",
            color: "danger",
          });
          if (from.name === "Home") {
            router.push({ path: "/dash/minhas-consultas" });
          } else {
            return next(false);
          }
      }
    }
  }
  return next();
});

export default router;
